<template>
  <div>
    <div class="row q-mb-md">
      <div class="col-12">
          <q-btn
            class="capitalize ctrl-button"
            color="grey-5"
            :label="`${$store.state.stringsStore.strings.action.toOverview}`"
            @click="$router.push('/help')"
            icon="keyboard_backspace"
          />
          <!-- Button which opens a support dialog where the user can explain his question -->
          <SupportButton></SupportButton>
      </div>
    </div>
    <div class="row gutter-sm q-mb-lg">
      <div class="col-md-6 col-sm-12 col-xs-12 q-pa-sm">
        <div class="card-block help-content detail">
          <div class="help-content__intro">
            <p class="help-content__page__title text-weight-bold">{{ help.title }}</p>
            <div v-html="help.intro"></div>
            <div class="help-content__body" v-html="help.body"></div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-12 col-xs-12 q-pa-sm">
        <div class="help-menu">
          <template v-for="(category, index) in toc">
            <p :key="index+'top'" class="text-weight-bold help-menu__title" v-text="index"></p>
            <hr :key="index+'hr'">
            <template v-if="index === 'general'">
              <ul class="help-menu__ul" :key="index">
                <template v-for="(module, i) in category">
                  <li class="help-menu__ul__li link" :class="{'active': activePage === module.title}" :key="i" v-text="module.title" @click="getHelp('general',module)"></li>
                </template>
              </ul>
            </template>
            <template v-else>
              <ul class="help-menu__ul" :key="index">
                <template v-for="(module, i) in category">
                  <li class="help-menu__ul__li" :key="i">
                    <span class="link__single help-menu__ul__li__label" :class="{'active': activePage === getString(module.label)}" v-if="module.pages.length === 1" @click="getHelp('module',module, true)">{{getString(module.label)}}</span>
                    <span v-else @click="getHelp('module',module)" class="help-menu__ul__li__label" style="pointer-events: none;">{{getString(module.label)}}</span>
                    <ul class="help-menu__ul" v-if="module.pages && module.pages.length > 1">
                      <template v-for="(page, i) in module.pages">
                        <li class="help-menu__ul__li link" :class="{'active': activePage === page.title}" :key="i" @click="getHelp('module',page)">{{page.title}}</li>
                      </template>
                    </ul>
                  </li>
                </template>
              </ul>
            </template>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import _get from 'lodash.get';
import SupportButton from '../support/SupportButton.vue';

export default {
  name: 'HelpDetail',
  components: {
    SupportButton,
  },
  created() {
    if (this.$route.params.type === 'general') {
      this.getHelpGeneral();
    } else {
      this.getHelpModule();
    }
    this.toc = (this.$store.state.helpStore.help) ? this.$store.state.helpStore.help : null;
  },
  data() {
    return {
      help: {},
      activePage: '',
      toc: {},
    };
  },
  methods: {
    getHelp(type, module, single) {
      // Define Url
      let url;
      url = module.location.replace('api/', '');
      if (single) {
        url = module.pages[0].location.replace('api/', '');
      }

      // Open cliked help
      this.$router.push(url);
      this.showHelp();
    },
    async showHelp() {
      // Build up URL to call
      let url = `/help/${this.$route.params.type}`;
      if (this.$route.params.module) {
        url += `/${this.$route.params.module}`;
      }

      // Call the API
      const response = await this.axios.get(url);
      try {
        if (response.data.page) {
          // Set fetched help in reactive data property
          this.help = response.data.page;
          // Set active page for adding active class
          this.activePage = response.data.page.title;
        } else {
          // Set fetched help in reactive data property
          this.help = response.data.toc[0];
          // Set active page for adding active class
          this.activePage = response.data.toc[0].title;
        }
      } catch (error) {
        console.warn(error);
      }

      const page = document.querySelector('.q-layout-page');
      const top = document.querySelector('.help-content');

      if (page.scrollTop >= 80) {
        top.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
      }
    },
    // Use lodash to fetch strings from store based on path string
    getString(path) {
      return _get(this.$store.state.stringsStore.strings, path);
    },
    async getHelpGeneral() {
      // Check if params are available in route
      if (this.$route.params.module && this.$route.params.type) {
        // Get help from module in route-params
        const response = await this.axios.get(`help/${this.$route.params.type}/${this.$route.params.module}`);
        // Check response and act accordingly
        try {
          if (response.data) {
            this.help = response.data.page;
            this.activePage = response.data.page.title;
          }
        } catch (error) {
          console.warn(error);
        }
      }
    },
    async getHelpModule() {
      // Check if params are available in route
      if (this.$route.params.module && this.$route.params.type) {
        // Get help from module in route-params
        const response = await this.axios.get(`help/${this.$route.params.type}`);
        // Check response and act accordingly
        try {
          if (response.data.toc[0]) {
            this.help = response.data.toc[0];
            this.activePage = response.data.toc[0].title;
          }
        } catch (error) {
          console.warn(error);
        }
      }
    },
  },
};
</script>

<style lang="stylus">
  @import '~variables';
  @import '../styles/components/help';

  .help-menu
    text-shadow white 0 1px 0
    color #9f9f9f

    hr
      height 1px !important
      border none
      border-bottom 1px solid rgba(0, 0, 0, 0.075)
      margin-bottom 2rem

    .link
      cursor pointer
      color inherit
      font-size 90%
      transition color .1s ease
      &__single
          font-weight bold
          display inline-block
          margin-top 0.5rem
          margin-bottom .5rem
          color $ctrl-darkmatter-lighten-1
          cursor pointer
          &:hover
            color $ctrl-blue
          &.active
            color $ctrl-blue
            font-weight bold

      &:hover
        color $ctrl-blue
      &.active
        color $ctrl-blue
        font-weight bold

    &__title
      color $ctrl-darkmatter
      text-transform capitalize
    &__ul
      list-style-type none
      margin-bottom 2rem
      padding-left 1.5rem
      &__li
        margin .5rem
        &__label
          font-weight bold
          display inline-block
          margin-top 1.5rem
          margin-bottom .5rem
          color $ctrl-darkmatter-lighten-1
        ul
          padding-left 0
.help-content
  h2
    color $ctrl-orange
    font-size 15px
    font-weight bold
    margin 10px 0
  h3
    color $ctrl-darkmatter-lighten-1
    font-size 14px
    font-weight 600
    margin 5px 0
  li
    margin 0.2rem 0

  &__body
    img
      max-width 100%
</style>
